module.exports = __webpack_public_path__ + "img/img-related12.879f746c.jpg";